import axios from "axios";
import { SERVER_URL } from "../config";
import { authHeader } from "../helpers";
import { handleResponse, handleError } from "../helpers";

let baseRoute = SERVER_URL;

export const leadService = {
  addLead,
  getLeads,
  getLeadsPaginated,
  uploadExcel,
  addNote,
  changeToSaleOpportunity,
  pinLead,
  editContactInformation,
  getCancellationReason,
  cancelLead,
  acceptLead,
};

function addLead(lead) {
  console.log("into leadService");

  const requestOptions = {
    headers: authHeader(),
  };

  return axios
    .post(`${baseRoute}/lead`, lead, { headers: requestOptions.headers })
    .then((res) => {
      handleResponse(res);
      return res.data;
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}

function getLeads({ sort = "0", phoneNumber = "0", filter = "0" }) {
  return axios.get(`${baseRoute}/lead/${sort}/${phoneNumber}/${filter}`, { headers: authHeader() })
    .then((res) => {
      handleResponse(res);
      res.data.filterOption = filter;
      return res.data;
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}

function getLeadsPaginated({
  sort = "0",
  phoneNumber = "0",
  filter = "0",
  family = "",
  page = 1,
  pageSize = 10,
} = {}) {
  return axios
    .get(`${baseRoute}/lead/paginated`, {
      headers: authHeader(),
      params: { sort, phoneNumber, filter, family, page, pageSize },
    })
    .then((res) => {
      handleResponse(res);
      res.data.filterOption = filter;
      return res.data;
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}

function uploadExcel(params) {
  console.log("into leadService");

  const requestOptions = {
    headers: authHeader(),
  };

  return axios
    .post(`${baseRoute}/lead/excel`, params, {
      headers: {
        ...requestOptions.headers,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log("res.user >> ");
      console.log(res.data);
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}

function addNote(params) {
  console.log("into leadService");

  const requestOptions = {
    headers: authHeader(),
  };

  return axios
    .post(`${baseRoute}/lead/add/note`, params, {
      headers: requestOptions.headers,
    })
    .then((res) => {
      console.log("res.user >> ");
      console.log(res.data);
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}



function changeToSaleOpportunity(params) {
  console.log("into leadService");

  const requestOptions = {
    headers: authHeader(),
  };

  return axios
    .post(`${baseRoute}/lead/changeToSaleOpportunity`, params, {
      headers: requestOptions.headers,
    })
    .then((res) => {
      console.log("res.user >> ");
      console.log(res.data);
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}

function pinLead(params) {
  console.log("into leadService");
  return axios
    .put(`${baseRoute}/lead/pin`, params, { headers: authHeader() })
    .then((res) => {
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}


function editContactInformation(params) {
  return axios
    .put(`${baseRoute}/lead/edit/contactInfo`, params, { headers: authHeader() })
    .then((res) => {
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}


function getCancellationReason() {
  return axios
    .get(`${baseRoute}/lead/cancel/reason`, { headers: authHeader() })
    .then((res) => {
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}

function cancelLead(params) {
  return axios
    .put(`${baseRoute}/lead/cancel`, params, { headers: authHeader() })
    .then((res) => {
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}


function acceptLead(params) {
  return axios
    .put(`${baseRoute}/lead/accept`, params, { headers: authHeader() })
    .then((res) => {
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}
